<!-- Toolbar -->
<div
  dir="ltr"
  class="flex items-center justify-between gap-sm px-md pb-md bg-white flex-wrap rounded-b-lg">
  <div class="flex items-center gap-[0.375rem]">
    @for (item of toolbarButtons(); track item.name) {
      <button
        [title]="item.title"
        [name]="item.name"
        [disabled]="disabled()"
        type="button"
        (click)="disabled() ? null : item.action()"
        [class.text-primary-400!]="item.isActive()"
        [class.bg-primary-50!]="item.isActive()"
        class="toolbar-btn text-neutral-500 hover:text-primary-400 disabled:text-neutral-300 disabled:hover:text-neutral-300 border-none cursor-pointer bg-transparent hover:bg-primary-50 disabled:hover:bg-transparent transition-colors duration-200 ease-in-out">
        <ng-container
          [ngComponentOutlet]="item.iconComponent"
          [ngComponentOutletInputs]="{
            iconClass: 'size-4 do-not-transform',
          }" />
      </button>

      @if (item.hasSeparator) {
        <div class="w-px h-[1.25rem] bg-neutral-300 mx-x-sm"></div>
      }
    }

    <!-- Hidden content for table grid tippy -->
    <div #tableGridContent style="display: none">
      <div
        class="p-sm bg-white rounded-md shadow-md max-h-[25rem] overflow-auto">
        <lib-table-grid-selector (tableSize)="insertTable($event)" />
      </div>
    </div>

    <!-- Hidden content for table actions tippy -->
    <div #tableActionsContent style="display: none">
      <div
        class="p-sm bg-white rounded-md shadow-md max-h-[25rem] overflow-auto min-w-[17.5rem]">
        <div class="grid grid-cols-2 gap-[0.25rem]">
          @for (action of tableActions(); track action.name) {
            <button
              [title]="action.title"
              type="button"
              [disabled]="action.isDisabled ? action.isDisabled() : false"
              (click)="action.action()"
              class="flex items-center gap-[0.5rem] p-[0.5rem] rounded-md text-neutral-700 hover:bg-neutral-100 disabled:text-neutral-300 disabled:hover:bg-transparent transition-colors duration-200 ease-in-out">
              <ng-container
                [ngComponentOutlet]="action.iconComponent"
                [ngComponentOutletInputs]="{
                  iconClass: 'size-5 do-not-transform',
                }" />
              <span class="text-start text-xs truncate">{{
                action.title
              }}</span>
            </button>
          }
        </div>
      </div>
    </div>

    <!-- Hidden content for link input tippy -->
    <div #linkInputContent style="display: none">
      <lib-link-input
        #linkInputComponent
        (linkInsert)="onLinkInsert($event)"
        (linkCancel)="onLinkCancel()" />
    </div>

    <ng-content />
  </div>

  <div class="ms-auto text-neutral-500 text-sm">
    @let chars = characterCount();
    <span
      [class]="
        chars > maxLength()
          ? 'text-destructive-900 font-semibold'
          : 'text-success-700 font-semibold'
      ">
      {{ chars }}</span
    >
    / {{ maxLength() }}
  </div>
</div>
